export default {
  name: "NineGridMirrorBinaryGrid",
  props: {
    grid: {
      type: Array,
      default: () => []
    },
    compact: {
      type: Boolean,
      default: false
    }
  }
};